import { useMessages } from "./auth-service-tools33.js";

const useFormErrorMessages = (errors, map) => {
  const flattenedMessageMap = Object.entries(map).reduce((acc, _ref) => {
    let [fieldName, errorTypes] = _ref;
    Object.entries(errorTypes).forEach((_ref2) => {
      let [key, value] = _ref2;
      acc[`${fieldName}.${key}`] = value;
    });
    return acc;
  }, {});
  const messages = useMessages(flattenedMessageMap);
  return Object.fromEntries(Object.entries(errors).map((_ref3) => {
    let [key, error] = _ref3;
    const value = messages[`${key}.${error.type}`] || messages[`${key}.default`];
    return [key, value];
  }));
};

export { useFormErrorMessages };